import { Capacitor } from '@capacitor/core';
import { supabase } from '../lib/supabase.js';
import { NATIVE_AUTH_CALLBACK } from '../auth/googleSignIn.js';

/**
 * Native deep-link handling (no-op on the web).
 *
 * Completes the system-browser Google OAuth round trip: Supabase redirects
 * to ge.fluent.app://auth-callback#access_token=…&refresh_token=… (implicit
 * flow — tokens live in the fragment), Android/iOS route that URL into the
 * app, we store the session and land on Home.
 */
export function initNativeDeepLinks(): void {
  if (!Capacitor.isNativePlatform()) return;
  void (async () => {
    const { App } = await import('@capacitor/app');
    const { Browser } = await import('@capacitor/browser');
    void App.addListener('appUrlOpen', ({ url }) => {
      void (async () => {
        if (!url.startsWith(NATIVE_AUTH_CALLBACK)) return;
        try {
          await Browser.close();
        } catch {
          // Custom Tab may already be gone — fine.
        }
        const fragment = url.split('#')[1] ?? '';
        const params = new URLSearchParams(fragment);
        const access_token = params.get('access_token');
        const refresh_token = params.get('refresh_token');
        if (access_token && refresh_token) {
          const { error } = await supabase.auth.setSession({ access_token, refresh_token });
          if (!error) {
            window.location.assign('/');
            return;
          }
        }
        // Error branch (user cancelled / provider error) — back to login.
        window.location.assign('/login');
      })();
    });
  })();
}
